module.exports = __webpack_public_path__ + "img/404.5fed059a.jpg";